import { render, staticRenderFns } from "./AssessmentQuestionV1.vue?vue&type=template&id=31d143a6&"
import script from "./AssessmentQuestionV1.vue?vue&type=script&lang=js&"
export * from "./AssessmentQuestionV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports